(function ($) {

	let debouncer = false;

	$(window).scroll(function () {
		if (debouncer) {
			return;
		}

		debouncer = setTimeout(() => {
			highlightActive();
			debouncer = false;
		}, 200);
	});

	function highlightActive() {
		const scrollTop = $(document).scrollTop();
		const anchors = $('body').find('.ez-toc-section');

		const offset = window.innerHeight * 0.75;
		let active = false;

		for (var i = 0; i < anchors.length; i++) {
			if (scrollTop + offset > $(anchors[i]).offset().top) {
				active = anchors[i];
			}
		}

		$('.ez-toc-link').removeClass('active');
		$('.ez-toc-link[href="#' + $(active).attr('id') + '"]').addClass('active');
	}

})(window.jQuery);
